import Decimal from 'decimal.js'
import type { DashboardCurrencyOverview } from '../api/dashboard.contract'
type Point = DashboardCurrencyOverview['grossSalesSeries'][number]

export type ChartMode = 'cumulative' | 'daily'

// At most 366 daily observations; preserve every day and sum with decimal precision.
export function chartBuckets(series: Point[], mode: ChartMode = 'cumulative') {
  let accumulated = new Decimal(0)
  return series.map((point) => {
    accumulated = accumulated.plus(point.amount.amount)
    return {
      label: point.label,
      through: point.label,
      amount: mode === 'cumulative' ? accumulated : new Decimal(point.amount.amount),
    }
  })
}
